import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'

// 避免重复导航 / 导航被取消时在控制台抛错导致页面卡住
const patchRouterMethod = (method) => {
  const original = Router.prototype[method]
  Router.prototype[method] = function patched(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return original.call(this, location, onResolve, onReject)
    }
    return original.call(this, location).catch(err => err)
  }
}
patchRouterMethod('push')
patchRouterMethod('replace')

import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/theme-vars.scss'
import './styles/element-theme.scss'
import './styles/index.scss'
import GasStatusTag from './components/GasStatusTag.vue'
import GasTableToolbar from './components/GasTableToolbar.vue'
import { loadStoredTheme } from './utils/applyTheme'

loadStoredTheme()

Vue.use(ElementUI)
Vue.component('GasStatusTag', GasStatusTag)
Vue.component('GasTableToolbar', GasTableToolbar)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
